<template>
  <div class="main">
    <div class="content">
      <div class="title">{{ data.title }}</div>
      <div class="time">{{ data.inputtime }}</div>
      <div v-html="data.content" class="htmlContent"></div>
    </div>
  </div>
</template>
<script>
import { newsDetail } from '@/services/api';

export default {
  data() {
    return {
      data: {},
      id: ''
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getData();
  },
  methods: {
    getData() {
      let data = {
        id: this.id
      };
      newsDetail(data).then(res => {
        this.data = res.data;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  background: #fff;
  .content {
    width: 1200px;
    margin: 0 auto;
    .title {
      font-size: 26px;
      font-weight: 500;
      color: #000000;
      line-height: 39px;
      text-align: center;
      padding-top: 70px;
    }
    .time {
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      color: #9ea7b3;
      line-height: 13px;
      margin-top: 10px;
      padding-bottom: 22px;
      border-bottom: 1px solid rgba(151, 151, 151, 0.25);
      margin-bottom: 30px;
    }
    .htmlContent {
      padding-bottom: 100px;
      /deep/ div {
        font-size: 20px;
      }
      h3 {
        line-height: 1.5 !important;
      }
      /deep/ img {
        width: 70% !important;
        height: auto !important;
        margin: 0 auto;
        display: block;
        float: none !important;
      }
    }
  }
}
@media (max-width: 1000px) {
  .main {
    .content {
      width: 100%;
      padding: 1px 48px;
      .title {
        font-size: 40px;
        color: #5e5e5e;
        letter-spacing: 0;
        font-weight: 500;
        margin-top: 40px;
        text-align: left;
        padding: 0;
        line-height: 1.5;
      }
      .time {
        font-size: 24px;
        color: #8d8e9d;
        letter-spacing: 0;
        font-weight: 400;
        margin-top: 40px;
        text-align: left;
        border: none;
        padding: 0;
      }
      .htmlContent {
        margin-top: 40px;
      }
    }
  }
}
</style>
<style>
.htmlContent p {
  padding: 12px 0;
  line-height: 1.5;
}
.htmlContent div {
  padding: 12px 0;
  line-height: 1.5;
}
</style>
